import { createContext, useContext } from 'react';

/** 挑圖用途：插入一張新圖，或替換某張既有圖（以 NodeView 的 getPos 在挑完當下重新定位）。 */
export type PickTarget = { mode: 'insert' } | { mode: 'replace'; getPos: () => number | undefined };

/** 編輯器內所有「放圖／換圖」入口共用的動作（工具列、插入選單、圖片浮動工具列）。 */
export interface ImagePickerApi {
  /** 開啟媒體庫 Drawer。 */
  openLibrary: (target: PickTarget) => void;
  /** 上傳新圖片並插入游標處（可多張）。 */
  uploadInsert: (files: File[]) => void;
  /** 上傳一張新圖片取代指定的那張圖。 */
  uploadReplace: (getPos: () => number | undefined, file: File) => void;
}

/**
 * 由 Tiptap.tsx 提供；NodeView 無法收 props，所以用 context 取得。
 * 唯讀預覽不提供 → 值為 null，各入口據此隱藏。
 */
export const ImagePickerContext = createContext<ImagePickerApi | null>(null);

export function useImagePicker(): ImagePickerApi | null {
  return useContext(ImagePickerContext);
}
